import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import { smoothScrollToElement } from '@/lib/smoothScroll'
import { useApolloNetworkStatus } from '@lib/apollo'
import getFirstQueryString from '@/utils/getFirstQueryString'

export default function useScrollToHashAnchor () {
  const done = useRef(false)
  const router = useRouter()
  const { numPendingQueries, numPendingMutations } = useApolloNetworkStatus()

  useEffect(() => {
    if (done.current) return

    const isLoading = numPendingQueries > 0 || numPendingMutations > 0
    const isReady = document.readyState === 'complete'
    if (!isReady || isLoading) return

    const timeout = setTimeout(() => {
      if (done.current) return

      const anchor = getFirstQueryString(router.query.anchor)
      if (!anchor) return
      try {
        const ele = document.querySelector(`[data-anchor="${anchor}"]`)
        if (!ele) return

        smoothScrollToElement(ele)
          .finally(() => {
            done.current = true
          })
      } catch (e) {
        console.error('[scroll error] ->', e)
      }
    }, 100)
    return () => clearTimeout(timeout)
  }, [router, numPendingQueries, numPendingMutations])
}
